"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getBettingOptions_1 = __importDefault(require("./getBettingOptions"));
var currency_symbol_map_1 = __importDefault(require("currency-symbol-map"));
// To calculate the limit of the new currency, search Google dollar to new currency.
// For example search query 'dollar to ukrainian hryvnia'.
var getCurrency = function () {
    var currentCurrency = getBettingOptions_1.default().currency;
    var currencies = {
        usd: {
            limit: 1000000,
            currency: 'USD',
            symbol: currency_symbol_map_1.default('USD'),
        },
        uah: {
            limit: 27000000,
            currency: 'UAH',
            symbol: currency_symbol_map_1.default('UAH'),
        },
        eur: {
            limit: 855000,
            currency: 'EUR',
            symbol: currency_symbol_map_1.default('EUR'),
        },
        rub: {
            limit: 58000000,
            currency: 'RUB',
            symbol: currency_symbol_map_1.default('RUB'),
        },
        aud: {
            limit: 1300000,
            currency: 'AUD',
            symbol: currency_symbol_map_1.default('AUD'),
        },
        cad: {
            limit: 1250000,
            currency: 'CAD',
            symbol: currency_symbol_map_1.default('CAD'),
        },
        cny: {
            limit: 6600000,
            currency: 'CNY',
            symbol: currency_symbol_map_1.default('CNY'),
        },
        sek: {
            limit: 8100000,
            currency: 'SEK',
            symbol: currency_symbol_map_1.default('SEK'),
        },
        nok: {
            limit: 8000000,
            currency: 'NOK',
            symbol: currency_symbol_map_1.default('NOK'),
        },
        jpy: {
            limit: 113000000,
            currency: 'JPY',
            symbol: currency_symbol_map_1.default('JPY'),
        },
        mbtc: {
            limit: 230000,
            currency: 'mBTC',
            symbol: "m" + currency_symbol_map_1.default('BTC'),
        },
        pln: {
            limit: 3932050,
            currency: 'PLN',
            symbol: currency_symbol_map_1.default('PLN'),
        },
        kzt: {
            limit: 433000000,
            currency: 'KZT',
            // NOTE: symbol from 'currency-symbol-map' is incorrect
            symbol: '₸',
        },
        brl: {
            limit: 5725000,
            currency: 'BRL',
            symbol: currency_symbol_map_1.default('BRL'),
        },
        inr: {
            limit: 74462050,
            currency: 'INR',
            symbol: currency_symbol_map_1.default('INR'),
        },
        azn: {
            limit: 1700000,
            currency: 'AZN',
            symbol: currency_symbol_map_1.default('AZN'),
        },
        pen: {
            limit: 3946843,
            currency: 'PEN',
            symbol: currency_symbol_map_1.default('PEN').slice(0, -1),
        },
        ars: {
            limit: 96355200,
            currency: 'ARS',
            symbol: currency_symbol_map_1.default('ARS'),
        },
        clp: {
            limit: 749220000,
            currency: 'CLP',
            symbol: currency_symbol_map_1.default('CLP'),
        },
        mxn: {
            limit: 19942840,
            currency: 'MXN',
            symbol: currency_symbol_map_1.default('MXN'),
        },
        cop: {
            limit: 3932000000,
            currency: 'COP',
            symbol: "COL" + currency_symbol_map_1.default('COP'),
        },
        czk: {
            limit: 23197000,
            currency: 'CZK',
            symbol: currency_symbol_map_1.default('CZK'),
        },
        php: {
            limit: 52341500,
            currency: 'PHP',
            symbol: currency_symbol_map_1.default('PHP'),
        },
        thb: {
            limit: 34252000,
            currency: 'THB',
            symbol: currency_symbol_map_1.default('THB'),
        },
        vnd: {
            limit: 22962500000,
            currency: 'VND',
            symbol: currency_symbol_map_1.default('VND'),
        },
        byn: {
            limit: 3363235,
            currency: 'BYN',
            symbol: currency_symbol_map_1.default('BYN'),
        },
    };
    if (!currentCurrency || !currencies[currentCurrency.toLowerCase()]) {
        return {
            maxPotentialWin: 999999999,
            currencyName: currentCurrency,
            currencySymbol: '',
        };
    }
    var maxPotentialWin = currencies[currentCurrency.toLowerCase()].limit;
    var currencyName = currencies[currentCurrency.toLowerCase()].currency;
    var currencySymbol = currencies[currentCurrency.toLowerCase()].symbol;
    return {
        maxPotentialWin: maxPotentialWin,
        currencyName: currencyName,
        currencySymbol: currencySymbol,
    };
};
exports.default = getCurrency;
//# sourceMappingURL=getCurrency.js.map